module.exports = __webpack_public_path__ + "img/1.6839c871.png";